import { createContext } from 'react';

import { AxisIdToScales } from './XYChartScales.context.js';
import { DataPoint } from '../../core/types/data-point.js';
import type { AxisIdToScaleDomain } from '../types/xy-chart-internals.js';
import type {
  AxisSelectConfig,
  XYChartSelectionDotMetadata,
} from '../types/xy-chart-selection.js';

export interface XYChartLinearSelectionContextValue {
  selectionConfigByAxisId: Map<string, AxisSelectConfig>;
  searchAllAxisDatapoints: (
    start: number,
    end: number,
    callback: (
      point: XYChartSelectionDotMetadata,
    ) => DataPoint | DataPoint[] | null,
    axesIds: string | string[],
    axisIdToScales: AxisIdToScales,
    axisIdToScaleDomain: AxisIdToScaleDomain,
    axisIdToIsRelative: Map<string, boolean>,
  ) => {
    axesCurrentSelection: Record<string, DataPoint[]>;
    highlightedDatapoints: DataPoint[];
  };
}

export const XYChartLinearSelectionContext = createContext<
  XYChartLinearSelectionContextValue | undefined
>(undefined);
